import React from "react";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTimes,
} from "react-icons/fa";

const FloatingSocialPanels = () => {
  return (
    <div className="hidden md:flex flex-col items-center gap-3 fixed top-1/2 right-0 -translate-y-1/2 z-40 pr-1">
      {/* Container with protruding effect */}
      <div className="flex flex-col gap-2 bg-white/90 backdrop-blur-sm shadow-xl rounded-l-xl pl-3 pr-1 py-2 border border-gray-100">
        <a
          href="https://wa.me/255754360590"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
          className="group relative -mr-6 hover:-mr-1 transition-all duration-300"
          title="Chat on WhatsApp"
        >
          <div className="w-12 h-12 rounded-full bg-[#25D366] text-white shadow-md flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
            <FaWhatsapp className="w-6 h-6" />
          </div>
        </a>
        <a
          href="https://www.facebook.com/jrinstitute"
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook"
          className="group relative -mr-6 hover:-mr-1 transition-all duration-300"
          title="Facebook"
        >
          <div className="w-12 h-12 rounded-full bg-[#1877F2] text-white shadow-md flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
            <FaFacebookF className="w-5 h-5" />
          </div>
        </a>
        <a
          href="https://www.instagram.com/jrinstituteoftechnology/?hl=en"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
          className="group relative -mr-6 hover:-mr-1 transition-all duration-300"
          title="Instagram"
        >
          <div className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-md flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
            <FaInstagram className="w-5 h-5" />
          </div>
        </a>
        <a
          href="https://www.youtube.com/channel/UCM6PtxyjAzWV8UiwbqvkMnw"
          target="_blank"
          rel="noreferrer"
          aria-label="YouTube"
          className="group relative -mr-6 hover:-mr-1 transition-all duration-300"
          title="YouTube"
        >
          <div className="w-12 h-12 rounded-full bg-[#FF0000] text-white shadow-md flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
            <FaYoutube className="w-6 h-6" />
          </div>
        </a>
        <a
          href="https://twitter.com/JriitTechnology/"
          target="_blank"
          rel="noreferrer"
          aria-label="Twitter"
          className="group relative -mr-6 hover:-mr-1 transition-all duration-300"
          title="Twitter/X"
        >
            <div className="w-12 h-12 rounded-full bg-black text-white shadow-md flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
              <FaTimes className="w-5 h-5" />
            </div>
        </a>
      </div>
    </div>
  );
};

export default FloatingSocialPanels;
